'use strict';
(function($){
	/*
	 * Vetology.FormHelper widget
	 *
	 * @description This ios the main Vetology widget to load the tools needed in the page
	 *				By the time this plugin runs, all othrs should have already been loaded, so this should be the last script to be loaded;
	 *
	 * @options					See description for each option
	 *
	 * @method	See description above each method
	 */
	$.widget(
		'Vetology.FormHelper',
		{
			"options": {},
			/*
			 * Vetology.FormHelper._init
			 *
			 * @description	Initializes the Vetology FormHelper
			 *
			 * @return NULL
			 *
			 */
			"_init": function(){
				var o = this;
				o._initEventHandler();
			},
			"_initEventHandler": function(){
				$("body").on("keyup", "textarea[maxlength]", function(i, obj){
					const t = $(this);
					var limit = parseInt(t.attr("maxlength"));
					var current = t.val().length;
					if(!t.hasClass("check_init")){
						t.addClass("check_init");
						t.closest("div").addClass("char_code_checker_block").append('<span class="char_code_checker label label-info"></span>');
					}
					if(current >= limit){
						t.closest(".char_code_checker_block").find(".char_code_checker").removeClass("label-info").addClass("label-danger").html("You have reached the character limit");
						return false;
					} else {
						t.closest(".char_code_checker_block").find(".char_code_checker").removeClass("label-danger").addClass("label-info").html("Chars left: " + (limit - current));
					}
				});
			},
			"getAutocompleteInput": function(name, value, class_names, params){
				var input = '<input class="value_holder" type="hidden" value="';
				if(value){
					input += value;
				}
				input += '" ';
				if(name){
					input += 'name="' + name + '"';
				}
				input += '>';
				input += '<input class="form-control ';
				if(class_names){
					input += class_names;
				}
				input += '" type="text" value="';
				if(value){
					input += value;
				}
				input += '" ';
				if(name){
					input += 'name="' + name + '"';
				}
				input += '>';
				return input;
			},
			"getBaseInput": function(name, value, class_names){
				var input = '<input class="form-control ';
				if(class_names){
					input += class_names;
				}
				input += '" type="text" value="';
				if(value){
					input += value;
				}
				input += '" ';
				if(name){
					input += 'name="' + name + '"';
				}
				input += '>';
				return input;
			},
			"getBaseSelect": function(name, value, class_names, options){
				var select = '<select class="form-control ';
				if(class_names){
					select += class_names;
				}
				select += '" ';
				if(name){
					select += 'name="' + name + '"';
				}
				select += '><option disabled="disabled" selected="selected">Select an option</option>';
				$.each(options, function(i, option){
					select += '<option ' + (i == value ? 'selected="selected"' : "") + ' value="' + i + '">' + option + '</option>';
				});
				select += '</select>';
				return select;
			},
			"getBaseTextEditor": function(name, value, class_names){
				var id = $("body").Vetology("getUniqueIdentifier");
				var editor = '<textarea id="' + id + '"  class="hide ';
				if(class_names){
					editor += class_names;
				}
				editor += '" ';
				if(name){
					editor += 'name="' + name + '"';
				}
				editor += '>';
				if(value){
					editor += value;
				}
				editor += '</textarea>';
				var er = setInterval(
					function(){
						var e = $("#" + id);
						if(e.length > 0 && window.ckeditorready){
							clearInterval(er);
							CKEDITOR.replace(
								id,
								{
									height: 300,
									extraPlugins: 'filemanager'
								}
							);
						}
					}, 10
				);
				return editor;
			}
		}
	);
})(jQuery);